import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useIsEnrichedContactFormFields } from "../hooks/useIsEnrichedContactFormFields";
import { ContactFormFields } from "./ContactFormFields";
import { EnrichedContactFormFields } from "./EnrichedContactFormFields/EnrichedContactFormFields";
import { useIsSimplifiedForm } from "../hooks/useIsSimplifiedForm";
import { CompactContactForm } from "../CompactContactForm/CompactContactForm";
// Prevent redundant rendering to avoid unexpected behavior with react-hook-form:
// This resolves the issue where entering an incorrect value in certain form fields
// causes arbitrary input fields to become unresponsive.
export const FormFieldsSection = memo(({ contactFormDatas, tracking }) => {
    const isEnrichedRentalContactLeads = useIsEnrichedContactFormFields();
    const isSimplifiedContactForm = useIsSimplifiedForm();
    if (isEnrichedRentalContactLeads) {
        return (_jsx(EnrichedContactFormFields, { contactFormDatas: contactFormDatas, tracking: tracking }));
    }
    if (isSimplifiedContactForm) {
        return (_jsx(CompactContactForm, { contactFormDatas: contactFormDatas, tracking: tracking }));
    }
    return (_jsx(ContactFormFields, { contactFormDatas: contactFormDatas, tracking: tracking }));
});
FormFieldsSection.displayName = "FormFieldsSection";
